import React from 'react'
import { Map } from 'immutable'
import { ImageSize } from './imageSizes'

export type ImageBase = {
  alt?: string
  urls: Map<ImageSize, string>
  keepOriginalSize: boolean
}

export const emptyImage: ImageBase = {
  urls: Map<ImageSize, string>(),
  keepOriginalSize: false
}

export type ImageOptions = {
  src: ImageSize
  srcset?: Map<ImageSize, string>
  pictureSources?: PictureSources[]
  sizes?: string
  width?: string
  height?: string
  lazyload: boolean
  placeholder?: string
  style?: React.CSSProperties
}

export type PictureSources = {
  srcset: Map<ImageSize, string>
  media: string
}

export const Image = (
  props: ImageBase &
    ImageOptions & {
      classNames: {
        image: string
        picture?: string
      }
    }
) => {
  const { urls, alt, classNames, src, width, height, srcset, lazyload, pictureSources, keepOriginalSize } = props
  const sizes = props.sizes !== undefined ? props.sizes : 'auto'
  const placeholder = props.placeholder !== undefined ? props.placeholder : '/images/empty.png'

  const wNumber = Number(width);
  const hNumber = Number(height);
  const w = isNaN(wNumber) ? width : `${wNumber}px`;
  const h = isNaN(hNumber) ? height : `${hNumber}px`;

  const img = ( keepOriginalSize ?
    <img
      className={`${classNames.image}${
        lazyload == true
          ? classNames.image.includes('lazyload')
            ? ''
            : ' lazyload'
          : classNames.image.includes('no-lazyload')
          ? ''
          : ' no-lazyload'
      }`}
      alt={alt}
      src={lazyload == true ? placeholder : urls?.get("full") || undefined}
      data-src={lazyload == true ? urls?.get("full") : undefined}
    />
    :
    <img
      className={`${classNames.image}${
        lazyload == true
          ? classNames.image.includes('lazyload')
            ? ''
            : ' lazyload'
          : classNames.image.includes('no-lazyload')
          ? ''
          : ' no-lazyload'
      }`}
      width={width}
      height={height}
      alt={alt}
      src={lazyload == true ? placeholder : urls?.get(src) || undefined}
      data-src={lazyload == true ? urls?.get(src) : undefined}
      srcSet={
        srcset
          ? lazyload == true
            ? undefined
            : srcset
                .filter((value, key) => urls.get(key) != undefined)
                .map((value, key) => `${urls.get(key)} ${value}`)
                .join(',')
          : undefined
      }
      data-srcset={
        srcset
          ? lazyload == true
            ? srcset
                .filter((value, key) => urls.get(key) != undefined)
                .map((value, key) => `${urls.get(key)} ${value}`)
                .join(',')
            : null
          : null
      }
      sizes={srcset ? (lazyload == true ? undefined : sizes) : undefined}
      data-sizes={srcset ? (lazyload == true ? sizes : undefined) : undefined}
      // style={{width: w, height: h}}
    />

  )

  return pictureSources && pictureSources.length > 0 ? (
    <picture className={classNames.picture}>
      {pictureSources.map((source) => (
        <source
          srcSet={
            lazyload == true
              ? undefined
              : source.srcset
                  .filter((value, key) => urls.get(key) !== undefined)
                  .map((value, key) => `${urls.get(key)} ${value}`)
                  .join(',')
          }
          data-srcset={
            lazyload == true
              ? source.srcset
                  .filter((value, key) => urls.get(key) !== undefined)
                  .map((value, key) => `${urls.get(key)} ${value}`)
                  .join(',')
              : undefined
          }
          media={source.media}
        />
      ))}
      {img}
    </picture>
  ) : (
    img
  )
}

export function urlToImage (url: string, ops?: { alt?: string, options?: ImageOptions }): ImageBase & ImageOptions {
  return {
    alt: ops?.alt ?? "image",
    urls: Map<ImageSize, string>([['full', url]]),
    src: 'full',
    keepOriginalSize: false,
    lazyload: true,
    ...ops?.options
  };
}
